import getCognitoAccessToken from './getCognitoAccessToken';

const rootUrl = process.env.NODE_ENV === 'development'
  ? '' : `${window.location.origin}`

const formatParams = (params) => {
  const getPairs = (urlParams, keys = []) => Object.entries(urlParams).reduce((pairs, [key, value]) => {
      if (typeof value === 'object') {
 pairs.push(...getPairs(value, [...keys, key]));
} else {
 pairs.push([[...keys, key], value]);
}
      return pairs;
    }, []);

  return `?${getPairs(params).
    map(([[key0, ...keysRest], value]) => `${key0}${keysRest.map((a) => `[${a}]`).join('')}=${value}`).
    join('&')}`;
};

const apiCall = ({ endpoint, params, method, }) => {
  return new Promise((resolve, reject) => {

    getCognitoAccessToken().then((accessToken) => {
      let fullUrl = (endpoint.indexOf(rootUrl) === -1) ? endpoint : rootUrl + endpoint;
      if (method === 'GET' && params) {
        fullUrl += formatParams(params);
      }
      const json = JSON.stringify(params);
      const request = new XMLHttpRequest();
      request.open(method, fullUrl, true);
      request.setRequestHeader('Content-type', 'application/json; charset=utf-8');
      request.setRequestHeader('Authorization', accessToken);

      request.onload = () => {
        if (request.status === 401) {
          window.location = '/dashboard/auth/sign-in';
        }

        if (request.status >= 200 && request.status < 300) {
          try {
            return resolve(JSON.parse(request.response));
          } catch (error) {
            return resolve(request.responseText);
          }
        }
        try {
          return reject(JSON.parse(request.response));
        } catch (error) {
          return reject(request.responseText);
        }
      };
      request.onerror = () => {
        return reject(new Error('Network request failed!'));
      };
      request.send(json);
    })
  });
};


export default apiCall;
